<template>
	<div class="content">
		<div v-if="isPdfLoading" class="pdf-loading-overlay">
			<div class="pdf-loading-spinner">
				<div class="pdf-loading-text">{{ pdfLoadingMsg || 'PDF 생성 중...' }}</div>
				<div v-if="pdfLoadingTotal > 0" class="pdf-loading-bar-wrap">
					<div class="pdf-loading-bar" :style="{ width: (pdfLoadingCurrent / pdfLoadingTotal * 100) + '%' }"></div>
				</div>
			</div>
		</div>
		<div v-if="loadSt" class="print-wrap">
			<div class="print-left">
				<div class="section-tit">슬라이드 선택/제외</div>
				<div class="table-wrap">
					<table class="table">
						<tr>
							<th>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opAll" @change="setAllCheck" />
									<span class="checkbox"></span>
								</label>
							</th>
							<th>구분</th>
						</tr>
						<tr>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opList[0]" @change="updateId" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>INTRO</td>
						</tr>
						<tr>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opList[1]" @change="updateId" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>비교</td>
						</tr>
						<tr>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opList[2]" @change="updateId" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>물건개요</td>
						</tr>
						<tr>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opList[3]" @change="updateId" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>임대정보</td>
						</tr>
						<tr>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opList[4]" @change="updateId" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>건축물정보</td>
						</tr>
						<tr><td><label class="input-checkbox"><input type="checkbox" v-model="invShow" @change="onInvestmentToggle" /><span class="checkbox"></span></label></td><td>투자분석</td></tr>
						<tr><td><label class="input-checkbox"><input type="checkbox" v-model="devShow" @change="onInvestmentToggle" /><span class="checkbox"></span></label></td><td>리모델링/신축</td></tr>
						<tr>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opList[5]" @change="updateId" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>건축 내/외부 사진</td>
						</tr>
						<tr>
							<td>
								<label class="input-checkbox">
									<input type="checkbox" v-model="opList[6]" @change="updateId" />
									<span class="checkbox"></span>
								</label>
							</td>
							<td>지도</td>
						</tr>
					</table>
				</div>
				<div class="section-tit mt-4 select">
					사진 선택/제외
					<select class="form-control select sm" v-model="isBid">
						<option v-for="i in bidList" :key="'ooopp_' + i" :value="i">{{ itemList[i].item.building_name }}</option>
					</select>
				</div>
				<ul class="table-list">
					<li class="table-list--item" v-for="(op, idx) in itemList[isBid].item.imgObjList" :key="'opp_' + idx">
						<div class="check">
							<label class="input-checkbox">
								<input type="checkbox" v-model="op.st" @change="updateId" :disabled="!opList[4]" />
								<span class="checkbox"></span>
							</label>
						</div>
						<div class="name">{{ op.name }}</div>
					</li>
				</ul>
				<InvestmentSidebarEditor v-if="itemList[isBid] && itemList[isBid].invState" :state="itemList[isBid].invState" :residential="invResidentialOf(isBid)" @change="onInvestmentEdit" />
				<SlideEditor
					v-if="itemList[isBid] && itemList[isBid].invState"
					:slides="itemList[isBid].slides"
					:uploading="slideUploading"
					@change="onSlideChange"
					@add-photo="onSelectedAddPhoto"
					@add-blank="onSelectedAddBlank" />
				<!-- <img :src="this.img" /> -->
				<div class="btn-wrap">
					<button type="button" class="btn btn-sm btn-secondary" @click="copyChartImg">출력</button>
				</div>
			</div>
			<div class="print-right" :style="watermarkStyle">
				<!-- 1. 인트로 -->
				<div v-if="opList[0]" id="capture_1" name="capture" class="print-section cover" :class="cobrandClass">
					<div class="tit">
						<div class="middle">사무실 제안서</div>
						<!-- <input type="text" class="text-center middle" value="(C)방이동 삼정빌딩" /> -->
					</div>
					<!-- <ol class="list">
						<li v-for="(i, idx) in indexList" :key="'index__' + idx" class="list-item">
							<span class="num">{{ i.idx }}</span> {{ i.name }}
						</li>
					</ol> -->
					<div class="logo"></div>
					<!-- <div class="bottom-text">
						본 Teaser는 WE'ONUS 가 제공하는 자료입니다.<br />
						본 Teaser는 자산의 계략적인 정보, 위치 등을 포함하고 있습니다.<br />
						본 건과 관련하여 궁금하신 사항이 있으실 경우에는<br />
						담당자에게 연락 부탁드립니다.
					</div> -->
				</div>
				<template v-if="opList[1]">
					<div
						v-for="(ilist, idx) in itemGroup"
						name="capture"
						:id="'capture_' + idx"
						:key="'capture_' + idx"
						class="print-section flex2-1"
					>
						<div class="print-tit">COMPARABLE(비교)</div>
						<div class="left">
							<div class="table-wrap">
								<table class="table type-input">
									<colgroup>
										<col width="25%" />
										<col width="25%" />
										<col width="25%" />
										<col width="25%" />
									</colgroup>
									<tr>
										<th>빌딩명</th>
										<th>{{ ilist.idList[0] ? itemList[ilist.idList[0]].item.building_name : '' }}</th>
										<th>{{ ilist.idList[1] ? itemList[ilist.idList[1]].item.building_name : '' }}</th>
										<th>{{ ilist.idList[2] ? itemList[ilist.idList[2]].item.building_name : '' }}</th>
									</tr>
									<tr>
										<th>사진</th>
										<td class="img">
											<img :src="ilist.idList[0] ? itemList[ilist.idList[0]].item.img : null" style="height: 100px" />
										</td>
										<td class="img">
											<img :src="ilist.idList[1] ? itemList[ilist.idList[1]].item.img : null" style="height: 100px" />
										</td>
										<td class="img">
											<img :src="ilist.idList[2] ? itemList[ilist.idList[2]].item.img : null" style="height: 100px" />
										</td>
									</tr>
									<tr>
										<th>주소</th>
										<td>{{ ilist.idList[0] ? itemList[ilist.idList[0]].coverAddr : '' }}</td>
										<td>{{ ilist.idList[1] ? itemList[ilist.idList[1]].coverAddr : '' }}</td>
										<td>{{ ilist.idList[2] ? itemList[ilist.idList[2]].coverAddr : '' }}</td>
									</tr>
									<tr>
										<th>보증금</th>
										<td>
											{{
												ilist.idList[0]
													? $formatMoney(itemList[ilist.idList[0]].item.deposit, $MONEY_FORMAT_TYPE.LOAN)
													: ''
											}}
										</td>
										<td>
											{{
												ilist.idList[1]
													? $formatMoney(itemList[ilist.idList[1]].item.deposit, $MONEY_FORMAT_TYPE.LOAN)
													: ''
											}}
										</td>
										<td>
											{{
												ilist.idList[2]
													? $formatMoney(itemList[ilist.idList[2]].item.deposit, $MONEY_FORMAT_TYPE.LOAN)
													: ''
											}}
										</td>
									</tr>
									<tr>
										<th>월세</th>

										<td class="txt-c--red">
											{{
												ilist.idList[0]
													? $formatMoney(itemList[ilist.idList[0]].item.monthly_rent, $MONEY_FORMAT_TYPE.LOAN)
													: ''
											}}
										</td>
										<td class="txt-c--red">
											{{
												ilist.idList[1]
													? $formatMoney(itemList[ilist.idList[1]].item.monthly_rent, $MONEY_FORMAT_TYPE.LOAN)
													: ''
											}}
										</td>
										<td class="txt-c--red">
											{{
												ilist.idList[2]
													? $formatMoney(itemList[ilist.idList[2]].item.monthly_rent, $MONEY_FORMAT_TYPE.LOAN)
													: ''
											}}
										</td>
									</tr>
									<tr>
										<th>관리비</th>
										<td class="txt-c--red">
											{{
												ilist.idList[0]
													? $formatMoney(itemList[ilist.idList[0]].item.main_fee, $MONEY_FORMAT_TYPE.LOAN)
													: ''
											}}
										</td>
										<td class="txt-c--red">
											{{
												ilist.idList[1]
													? $formatMoney(itemList[ilist.idList[1]].item.main_fee, $MONEY_FORMAT_TYPE.LOAN)
													: ''
											}}
										</td>
										<td class="txt-c--red">
											{{
												ilist.idList[2]
													? $formatMoney(itemList[ilist.idList[2]].item.main_fee, $MONEY_FORMAT_TYPE.LOAN)
													: ''
											}}
										</td>
									</tr>
									<tr>
										<th>월고정비</th>
										<td class="txt-c--red">
											{{
												ilist.idList[0]
													? $formatMoney(itemList[ilist.idList[0]].item.monthly_fixed, $MONEY_FORMAT_TYPE.LOAN)
													: ''
											}}
										</td>
										<td class="txt-c--red">
											{{
												ilist.idList[1]
													? $formatMoney(itemList[ilist.idList[1]].item.monthly_fixed, $MONEY_FORMAT_TYPE.LOAN)
													: ''
											}}
										</td>
										<td class="txt-c--red">
											{{
												ilist.idList[2]
													? $formatMoney(itemList[ilist.idList[2]].item.monthly_fixed, $MONEY_FORMAT_TYPE.LOAN)
													: ''
											}}
										</td>
									</tr>
									<tr>
										<th>전용면적</th>
										<td class="txt-c--red">
											{{
												ilist.idList[0]
													? $formatArea(itemList[ilist.idList[0]].item.net_area_m2) + '㎡(' + $formatArea(itemList[ilist.idList[0]].item.net_area_py) + '평)'
													: ''
											}}
										</td>
										<td class="txt-c--red">
											{{
												ilist.idList[1]
													? $formatArea(itemList[ilist.idList[1]].item.net_area_m2) + '㎡(' + $formatArea(itemList[ilist.idList[1]].item.net_area_py) + '평)'
													: ''
											}}
										</td>
										<td class="txt-c--red">
											{{
												ilist.idList[2]
													? $formatArea(itemList[ilist.idList[2]].item.net_area_m2) + '㎡(' + $formatArea(itemList[ilist.idList[2]].item.net_area_py) + '평)'
													: ''
											}}
										</td>
									</tr>
									<tr>
										<th>전용률</th>
										<td>{{ ilist.idList[0] ? itemList[ilist.idList[0]].item.ex_rate + '%' : '' }}</td>
										<td>{{ ilist.idList[1] ? itemList[ilist.idList[1]].item.ex_rate + '%' : '' }}</td>
										<td>{{ ilist.idList[2] ? itemList[ilist.idList[2]].item.ex_rate + '%' : '' }}</td>
									</tr>
									<tr>
										<th>임대면적</th>
										<td>
											{{
												ilist.idList[0]
													? $formatArea(itemList[ilist.idList[0]].item.rent_area_m2) + '㎡(' + $formatArea(itemList[ilist.idList[0]].item.rent_area_py) + '평)'
													: ''
											}}
										</td>
										<td>
											{{
												ilist.idList[1]
													? $formatArea(itemList[ilist.idList[1]].item.rent_area_m2) + '㎡(' + $formatArea(itemList[ilist.idList[1]].item.rent_area_py) + '평)'
													: ''
											}}
										</td>
										<td>
											{{
												ilist.idList[2]
													? $formatArea(itemList[ilist.idList[2]].item.rent_area_m2) + '㎡(' + $formatArea(itemList[ilist.idList[2]].item.rent_area_py) + '평)'
													: ''
											}}
										</td>
									</tr>
									<tr>
										<th>층정보</th>
										<td>{{ ilist.idList[0] ? itemList[ilist.idList[0]].item.floor_info : '' }}</td>
										<td>{{ ilist.idList[1] ? itemList[ilist.idList[1]].item.floor_info : '' }}</td>
										<td>{{ ilist.idList[2] ? itemList[ilist.idList[2]].item.floor_info : '' }}</td>
									</tr>
									<tr>
										<th>평당임대료</th>
										<td class="txt-c--red">
											{{
												ilist.idList[0]
													? $formatMoney(itemList[ilist.idList[0]].item.rent_py_price, $MONEY_FORMAT_TYPE.LOAN)
													: ''
											}}
										</td>
										<td class="txt-c--red">
											{{
												ilist.idList[1]
													? $formatMoney(itemList[ilist.idList[1]].item.rent_py_price, $MONEY_FORMAT_TYPE.LOAN)
													: ''
											}}
										</td>
										<td class="txt-c--red">
											{{
												ilist.idList[2]
													? $formatMoney(itemList[ilist.idList[2]].item.rent_py_price, $MONEY_FORMAT_TYPE.LOAN)
													: ''
											}}
										</td>
									</tr>
									<tr>
										<th>입주현황</th>
										<td>
											{{ ilist.idList[0] ? itemList[ilist.idList[0]].item.in_status : '' }}
										</td>
										<td>
											{{ ilist.idList[1] ? itemList[ilist.idList[1]].item.in_status : '' }}
										</td>
										<td>
											{{ ilist.idList[2] ? itemList[ilist.idList[2]].item.in_status : '' }}
										</td>
									</tr>
									<tr>
										<th>주차(무료/유료)</th>
										<td>
											{{
												ilist.idList[0]
													? '무료' +
													  itemList[ilist.idList[0]].item.free_parking +
													  '대 / ' +
													  '유료' +
													  itemList[ilist.idList[0]].item.fee_paring +
													  '대'
													: ''
											}}
										</td>
										<td>
											{{
												ilist.idList[1]
													? '무료' +
													  itemList[ilist.idList[1]].item.free_parking +
													  '대 / ' +
													  '유료' +
													  itemList[ilist.idList[1]].item.fee_paring +
													  '대'
													: ''
											}}
										</td>
										<td>
											{{
												ilist.idList[2]
													? '무료' +
													  itemList[ilist.idList[2]].item.free_parking +
													  '대 / ' +
													  '유료' +
													  itemList[ilist.idList[2]].item.fee_paring +
													  '대'
													: ''
											}}
										</td>
									</tr>
									<tr>
										<th>화장실유형</th>
										<td>
											{{ ilist.idList[0] ? itemList[ilist.idList[0]].item.bathroom_type : '' }}
										</td>
										<td>
											{{ ilist.idList[1] ? itemList[ilist.idList[1]].item.bathroom_type : '' }}
										</td>
										<td>
											{{ ilist.idList[2] ? itemList[ilist.idList[2]].item.bathroom_type : '' }}
										</td>
									</tr>
									<tr>
										<th>인테리어</th>
										<td>{{ ilist.idList[0] ? $INTERIOR_TYPE[itemList[ilist.idList[0]].item.interior_type] : '' }}</td>
										<td>{{ ilist.idList[1] ? $INTERIOR_TYPE[itemList[ilist.idList[1]].item.interior_type] : '' }}</td>
										<td>{{ ilist.idList[2] ? $INTERIOR_TYPE[itemList[ilist.idList[2]].item.interior_type] : '' }}</td>
									</tr>
									<tr>
										<th>렌트프리</th>
										<td>
											<template v-if="itemList[ilist.idList[0]]?.item.rent_free == 'selet'">
												{{ itemList[ilist.idList[0]]?.item.rent_free_month }}개월
											</template>
											<template v-else>{{ $RENT_FREE[itemList[ilist.idList[0]]?.item.rent_free] }}</template>
										</td>
										<td>
											<template v-if="itemList[ilist.idList[1]]?.item.rent_free == 'selet'">
												{{ itemList[ilist.idList[1]]?.item.rent_free_month }}개월
											</template>
											<template v-else>{{ $RENT_FREE[itemList[ilist.idList[1]]?.item.rent_free] }}</template>
										</td>
										<td>
											<template v-if="itemList[ilist.idList[2]]?.item.rent_free == 'selet'">
												{{ itemList[ilist.idList[2]]?.item.rent_free_month }}개월
											</template>
											<template v-else>{{ $RENT_FREE[itemList[ilist.idList[2]]?.item.rent_free] }}</template>
										</td>
									</tr>
									<tr>
										<th>주변역/거리</th>
										<td>
											{{ ilist.idList[0] ? itemList[ilist.idList[0]].item.substation : '' }}
											{{
												ilist.idList[0] && itemList[ilist.idList[0]].item.substation_distance
													? '(' + itemList[ilist.idList[0]].item.substation_distance + 'm' + ')'
													: ''
											}}
										</td>
										<td>
											{{ ilist.idList[1] ? itemList[ilist.idList[1]].item.substation : '' }}
											{{
												ilist.idList[1] && itemList[ilist.idList[1]].item.substation_distance
													? '(' + itemList[ilist.idList[1]].item.substation_distance + 'm' + ')'
													: ''
											}}
										</td>
										<td>
											{{ ilist.idList[2] ? itemList[ilist.idList[2]].item.substation : '' }}
											{{
												ilist.idList[2] && itemList[ilist.idList[2]].item.substation_distance
													? '(' + itemList[ilist.idList[2]].item.substation_distance + 'm' + ')'
													: ''
											}}
										</td>
									</tr>
									<tr>
										<th>승강기</th>
										<td>{{ ilist.idList[0] ? itemList[ilist.idList[0]].item.ev_cnt : '' }}</td>
										<td>{{ ilist.idList[1] ? itemList[ilist.idList[1]].item.ev_cnt : '' }}</td>
										<td>{{ ilist.idList[2] ? itemList[ilist.idList[2]].item.ev_cnt : '' }}</td>
									</tr>
									<tr>
										<th>준공년도/리모델링</th>
										<td>
											{{ ilist.idList[0] ? $dateFormat2(itemList[ilist.idList[0]].item.build_date) : '' }}
											{{
												ilist.idList[0] && itemList[ilist.idList[0]].item.remodel_date
													? ' / ' + $dateFormat2(itemList[ilist.idList[0]].item.remodel_date)
													: ''
											}}
										</td>
										<td>
											{{ ilist.idList[1] ? $dateFormat2(itemList[ilist.idList[1]].item.build_date) : '' }}
											{{
												ilist.idList[1] && itemList[ilist.idList[1]].item.remodel_date
													? ' / ' + $dateFormat2(itemList[ilist.idList[1]].item.remodel_date)
													: ''
											}}
										</td>
										<td>
											{{ ilist.idList[2] ? $dateFormat2(itemList[ilist.idList[2]].item.build_date) : '' }}
											{{
												ilist.idList[2] && itemList[ilist.idList[2]].item.remodel_date
													? ' / ' + $dateFormat2(itemList[ilist.idList[2]].item.remodel_date)
													: ''
											}}
										</td>
									</tr>
								</table>
							</div>
						</div>
						<div class="right">
							<!-- <div class="section-tit">서울 강남구</div> -->
							<!-- <div class="section-tit"></div> -->
							<div class="map-wrap">
								<div :id="ilist.mapIdName"></div>
							</div>
							<div class="table-wrap">
								<div class="txt-right txt-size--sm mb-1 mt-1">단위:원</div>
								<table class="table type-input">
									<tr>
										<th>NO.</th>
										<th>빌딩이름</th>
										<th>금액(대지평당금액)</th>
										<th>대지평수/연면적</th>
										<th>임대료</th>
										<th>수익률</th>
									</tr>
									<tr v-for="(ii, idx) in ilist.idList" :key="'mta_idx_' + idx">
										<!-- itemList[ilist.idList[1]].item.land_size_m2 -->
										<td>0{{ idx + 1 }}</td>
										<td>
											{{ itemList[ilist.idList[idx]].item.building_name }}<br />
											{{
												$getFloorString(
													itemList[ilist.idList[idx]].item.floor_cnt_B,
													itemList[ilist.idList[idx]].item.floor_cnt_F,
												)
											}}
										</td>
										<td>
											{{ $formatMoney(itemList[ilist.idList[idx]].item.sell_price, $MONEY_FORMAT_TYPE.LOAN) }}<br />
											(평당
											{{
												$formatNumber(
													(
														itemList[ilist.idList[idx]].item.sell_price / itemList[ilist.idList[idx]].item.land_size_p
													).toFixed(2),
												)
											}}만원)
										</td>
										<td>
											{{ $formatArea(itemList[ilist.idList[idx]].item.land_size_p) }}평 /
											{{ $formatArea(itemList[ilist.idList[idx]].item.total_size_p) }}평
										</td>
										<td>{{ $formatNumber(itemList[ilist.idList[idx]].item.monthly_rent) }}만원</td>
										<td>{{ itemList[ilist.idList[idx]].item.earning_rate }}%</td>
									</tr>
								</table>
							</div>
						</div>
					</div>
				</template>
				<template v-for="i in bidList" :key="'capture_item_x_' + i">
					<!-- 2. 물건개요 -->
					<div
						v-if="opList[2]"
						:id="'capture_item_2_' + i"
						:key="'capture_item_2_' + i"
						name="capture"
						class="print-section flex1-2"
					>
						<div class="print-tit">OVERVIEW(개요) - {{ itemList[i].item.building_name }}</div>
						<div class="left">
							<div class="img-wrap"><img :src="itemList[i].item.img" alt="" style="width: 369px; height: 455px" /></div>
							<div class="map-warp" :id="'map_0_' + i"></div>
						</div>
						<div class="right">
							<div class="section-tit section-tit--print-header" style="margin-bottom: 5px;">물건명 및 주소</div>
							<div class="sub" style="font-size: 20px; font-weight: 600; margin-bottom: 5px;">{{ itemList[i].item.building_name }}</div>
							<div class="sub-addr">{{ itemList[i].bodyAddr }}</div>
							<div class="flex">
								<div>
									<div class="section-tit section-tit--print-header">임대정보</div>
									<div class="table-wrap">
										<table class="table type-input text-left">
											<colgroup>
												<col width="20%" />
												<col width="30%" />
												<col width="20%" />
												<col width="30%" />
											</colgroup>
											<tr>
												<th style="font-weight: 700;">주소</th>
												<td colspan="3" style="font-weight: 700;">{{ itemList[i].bodyAddr }}</td>
											</tr>
											<tr>
												<th>보증금</th>
												<td colspan="3" class="txt-c--red">
													{{ $formatMoney(itemList[i].item.deposit, $MONEY_FORMAT_TYPE.LOAN) }}
												</td>
											</tr>
											<tr>
												<th>월세</th>
												<td colspan="3" class="txt-c--red">
													{{ $formatMoney(itemList[i].item.monthly_rent, $MONEY_FORMAT_TYPE.LOAN) }}
												</td>
											</tr>
											<tr>
												<th>관리비</th>
												<td colspan="3">{{ $formatMoney(itemList[i].item.main_fee, $MONEY_FORMAT_TYPE.LOAN) }}</td>
											</tr>
											<tr>
												<th>관리비 지출·수익</th>
												<td colspan="3">{{ itemList[i].item.ex_sum_mgr_fee_out ? $formatMoney(itemList[i].item.ex_sum_mgr_fee_out, $MONEY_FORMAT_TYPE.LOAN) : '-' }} / {{ (itemList[i].item.ex_sum_mgr_fee && itemList[i].item.ex_sum_mgr_fee_out) ? $formatMoney(itemList[i].item.ex_sum_mgr_fee - itemList[i].item.ex_sum_mgr_fee_out, $MONEY_FORMAT_TYPE.LOAN) : '-' }}</td>
											</tr>
											<tr>
												<th>월고정비</th>
												<td colspan="3" class="txt-c--red">
													{{ $formatMoney(itemList[i].item.monthly_fixed, $MONEY_FORMAT_TYPE.LOAN) }}
												</td>
											</tr>
											<tr>
												<th>전용면적</th>
												<td class="txt-c--red">{{ $formatArea(itemList[i].item.net_area_py) }}평</td>
												<th>전용률</th>
												<td>{{ itemList[i].item.ex_rate }}%</td>
											</tr>
											<tr>
												<th>임대면적</th>
												<td colspan="3">{{ $formatArea(itemList[i].item.rent_area_py) }}평</td>
											</tr>
											<tr>
												<th>평당임대료</th>
												<td colspan="3" class="txt-c--red">
													{{ $formatMoney(itemList[i].item.rent_py_price, $MONEY_FORMAT_TYPE.LOAN) }}
												</td>
											</tr>
											<tr>
												<th>층정보</th>
												<td>{{ itemList[i].item.floor_info }}</td>
												<th>입주현황</th>
												<td>{{ itemList[i].item.in_status }}</td>
											</tr>
											<tr>
												<th>무료 주차대수</th>
												<td>{{ itemList[i].item.free_parking }}</td>
												<th>유료 주차대수</th>
												<td>{{ itemList[i].item.fee_paring }}</td>
											</tr>
											<tr>
												<th>화장실 유형</th>
												<td colspan="3">{{ itemList[i].item.bathroom_type }}</td>
											</tr>
											<tr>
												<th>인테리어</th>
												<td colspan="3">{{ $INTERIOR_TYPE[itemList[i].item.interior_type] }}</td>
											</tr>
											<tr>
												<th>렌트프리</th>
												<td colspan="3">
													<template v-if="itemList[i].item.rent_free == 'selet'">
														{{ itemList[i].item.rent_free_month }}개월
													</template>
													<template v-else>{{ $RENT_FREE[itemList[i].item.rent_free] }}</template>
												</td>
											</tr>
										</table>
									</div>
								</div>
								<div>
									<div class="section-tit section-tit--print-header">토지정보</div>
									<div class="table-wrap">
										<table class="table type-input text-left">
											<colgroup>
												<col width="50%" />
												<col width="50%" />
											</colgroup>
											<tr>
												<th class="txt-c--red">주변역</th>
												<td class="txt-c--red">{{ itemList[i].item.substation }}</td>
											</tr>
											<tr>
												<th class="txt-c--red">거리</th>
												<td class="txt-c--red">
													{{ itemList[i].item.substation_distance ? itemList[i].item.substation_distance + 'm' : '' }}
												</td>
											</tr>
											<tr>
												<th>대지면적</th>
												<td>{{ $formatArea(itemList[i].item.land_size_m2) }}㎡ [{{ $formatArea(itemList[i].item.land_size_p) }}평]</td>
											</tr>
											<tr>
												<th>용도지역</th>
												<td>{{ itemList[i].item.cfg_val1 }}</td>
											</tr>
											<tr>
												<th>공시지가</th>
												<td>{{ $formatMoney(itemList[i].item.public_land_price, $MONEY_FORMAT_TYPE.LOAN) }}</td>
											</tr>
											<tr>
												<th>도로사항</th>
												<td>
													<template v-if="itemList[i].item.roadwide_1">{{ itemList[i].item.roadwide_1 }}m</template>
													<template v-if="itemList[i].item.roadwide_2">,{{ itemList[i].item.roadwide_2 }}m</template>
													<template v-if="itemList[i].item.roadwide_3">,{{ itemList[i].item.roadwide_3 }}m</template>
													<template v-if="itemList[i].item.roadwide_4">,{{ itemList[i].item.roadwide_4 }}m</template>
													<template v-if="itemList[i].item.chk_road_coner == 'Y'">,코너</template>
													<template v-if="itemList[i].item.chk_road_dual == 'Y'">,양면</template>
													&nbsp;
													<template v-if="itemList[i].item.road_name">[{{ itemList[i].item.road_name }}]</template>
												</td>
											</tr>
										</table>
									</div>
									<div class="section-tit section-tit--print-header mt-4">건축물정보</div>
									<div class="table-wrap">
										<table class="table type-input text-left">
											<colgroup>
												<col width="50%" />
												<col width="50%" />
											</colgroup>
											<tr>
												<th>준공연도/리모델링</th>
												<td>
													{{ $dateFormat(itemList[i].item.build_date) }}
													{{ itemList[i].item.remodel_date ? '/ ' + $dateFormat(itemList[i].item.remodel_date) : '' }}
												</td>
											</tr>
											<tr>
												<th class="txt-c--red">승강기</th>
												<td class="txt-c--red">{{ itemList[i].item.ev_cnt ? itemList[i].item.ev_cnt + '대' : '' }}</td>
											</tr>
											<tr>
												<th>냉/난방식</th>
												<td>{{ itemList[i].item.heat_type_name }}</td>
											</tr>
											<tr>
												<th>규모</th>
												<td>
													{{ $getFloorString(itemList[i].item.floor_cnt_B, itemList[i].item.floor_cnt_F) }}
												</td>
											</tr>
											<tr>
												<th>건폐율/용적률</th>
												<td>{{ $formatRatio(itemList[i].item.bl_ratio) }}/{{ $formatRatio(itemList[i].item.fa_ratio) }}</td>
											</tr>
											<tr>
												<th>주차방식/대수</th>
												<td>
													<template v-if="itemList[i].item.park_type_name"
														>{{ itemList[i].item.park_type_name }} /</template
													>
													법정 {{ itemList[i].item.park_cnt_law }}대 / 실제 {{ itemList[i].item.park_cnt_real }}대
												</td>
											</tr>
											<tr>
												<th>연면적</th>
												<td colspan="3">
													{{ $formatArea(itemList[i].item.total_size_m2) }}㎡ [{{ $formatArea(itemList[i].item.total_size_p) }}평]
												</td>
											</tr>
											<tr>
												<th>건축면적</th>
												<td colspan="3">
													{{ $formatArea(itemList[i].item.build_size_m2) }}㎡ [{{ $formatArea(itemList[i].item.build_size_p) }}평]
												</td>
											</tr>
										</table>
									</div>
								</div>
							</div>
							<div class="section-tit mt-4">특징</div>
							<ul class="dot-list box-line">
								<div v-html="itemList[i].item.memo.split('\n').join('<br />')"></div>
							</ul>
						</div>
					</div>
					<!-- 3. 임대정보 -->
					<div
						v-if="opList[3]"
						:id="'capture_item_3_' + i"
						:key="'capture_item_3_' + i"
						name="capture"
						class="print-section"
					>
						<div class="print-tit">STACKING PLAN - {{ itemList[i].item.building_name }}</div>
						<div class="table-wrap">
							<table class="table sm">
								<thead>
									<tr>
										<th>층</th>
										<th>임대면적(㎡)</th>
										<th>임대면적(평)</th>
										<th>용도</th>
										<th>보증금</th>
										<th>월세</th>
										<th>관리비</th>
										<th>만기</th>
										<th>비고</th>
									</tr>
								</thead>
								<tbody>
									<tr :key="'rent_' + rent.building_rent_uid" v-for="rent in itemList[i].rentList" :class="{ 'rent-excluded': rent.except_flag === 'Y' }">
										<th>{{ rent.rent_floor }}</th>
										<td>{{ $formatArea(rent.rent_size_m2) }}</td>
										<td>{{ $formatArea(rent.rent_size_p) }}</td>
										<td>{{ rent.rent_usage }}</td>
										<td>{{ $formatNumber(rent.rent_deposit) }}</td>
										<td>{{ $formatNumber(rent.rent_money) }}</td>
										<td>{{ rent.mgr_fee ? $formatNumber(rent.mgr_fee) : 0 }}</td>
										<td>{{ rent.end_date }}</td>
										<td>{{ rent.memo }}</td>
									</tr>
									<tr>
										<th class="bg-blue">합계</th>
										<td class="bg-blue">{{ $formatNumber(itemList[i].totalData.m2) }}</td>
										<td class="bg-blue">{{ $formatNumber(itemList[i].totalData.py) }}</td>
										<td class="bg-blue"></td>
										<td class="bg-blue">{{ $formatNumber(itemList[i].totalData.deposit) }}</td>
										<td class="bg-blue">{{ $formatNumber(itemList[i].totalData.money) }}</td>
										<td class="bg-blue">{{ $formatNumber(itemList[i].totalData.mgr) }}</td>
										<td class="bg-blue"></td>
										<td class="bg-blue"></td>
									</tr>
								</tbody>
							</table>
						</div>
						<div class="table-text">* 임대차계약서 상 임대면적의 총합과 건축물대장 상 연면적이 다소 차이가 있음</div>
					</div>
					<!-- 4. 건축물정보 -->
					<div
						v-if="opList[4]"
						:id="'capture_item_4_' + i"
						:key="'capture_item_4_' + i"
						name="capture"
						class="print-section"
					>
						<div class="print-tit">BUILDING REGISTER - {{ itemList[i].item.building_name }}</div>
						<div class="table-wrap">
							<table class="table sm">
								<thead>
									<tr>
										<th>층</th>
										<th>면적(㎡)</th>
										<th>평수</th>
										<th>층별용도</th>
									</tr>
								</thead>
								<tbody>
									<tr :key="'floor_' + floor.building_floor_uid" v-for="floor in itemList[i].floorList" :class="{ 'floor-excluded': floor.chk_except === 'Y' }">
										<td>{{ floor.flrNoNm }}</td>
										<td>{{ $formatArea(floor.area_m2) }}</td>
										<td>{{ $formatArea(floor.area_py) }}</td>
										<td>{{ floor.name }}</td>
									</tr>
									<tr>
										<td class="bg-blue">합계</td>
										<td class="bg-blue">{{ itemList[i].totalFloorData.m2 }}</td>
										<td class="bg-blue">{{ itemList[i].totalFloorData.py }}</td>
										<td class="bg-blue"></td>
									</tr>
								</tbody>
							</table>
						</div>
					</div>
					<InvestmentAnalysisPage v-if="invShow && invAcqOf(i)" :id="'capture_inv_' + i" :acq="invAcqOf(i)" :tax-rate="itemList[i].invState.taxRate" :broker-rate="itemList[i].invState.brokerRate" :ltv="itemList[i].invState.ltv" :loan-rate="itemList[i].invState.loanRate" :noi="itemList[i].invState.noi" :residential="invResidentialOf(i)" />
					<DevelopmentPlanPage v-if="devShow && invDevOf(i) && invFundingOf(i)" :id="'capture_dev_' + i" :dev="invDevOf(i)" :funding="invFundingOf(i)" />
					<!-- 5. 건물 내/외부 (사진 여러개)-->
					<template v-if="opList[5]">
						<div
							v-for="(pic, idx) in itemList[i].item.imgObj"
							:id="'picture_' + itemList[i].item.building_uid + '_' + idx"
							:key="'picture_' + itemList[i].item.building_uid + '_' + idx"
							class="print-section flex"
							name="capture"
						>
							<div class="print-tit">PHOTO - {{ itemList[i].item.building_name }}</div>
							<template v-for="(l, ll) in pic" :key="idx + '_' + ll + '_' + 'pic_' + itemList[i].item.building_uid">
								<div v-if="(ll = 0)" class="left">
									<div class="section-tit">{{ l.name }}</div>
									<div class="img-wrap">
										<img :src="l.img" alt="" style="width: 540px; height: 650px" />
									</div>
								</div>
								<div v-else class="right">
									<div class="section-tit">{{ l.name }}</div>
									<div class="img-wrap">
										<img :src="l.img" alt="" style="width: 540px; height: 650px" />
									</div>
								</div>
							</template>
						</div>
					</template>
					<!-- 6. 지도 -->
					<div v-show="opList[6]" :id="'capture_item_6_' + i" name="capture" class="print-section flex">
						<div class="left">
							<div class="print-tit">MAP - {{ itemList[i].item.building_name }}</div>
							<div :id="'map_1_' + i"></div>
						</div>
						<div class="right">
							<div class="print-tit">MAP - {{ itemList[i].item.building_name }}</div>
							<div :id="'map_2_' + i"></div>
						</div>
					</div>
					<!-- #7 부록 슬라이드(매물별, 맨 뒤) -->
					<SlidePage v-for="s in (itemList[i].slides || [])" :key="'slide_' + i + '_' + s.id" :id="'slide_' + i + '_' + s.id" name="capture" :slide="s" />
					<!-- 7. end -->
					<div v-if="i == bidList[bidList.length - 1]" name="capture" id="capture_99" class="print-section cover end">
						<ul class="info" :class="cobrandClass">
							<li class="info-item name">
								<span class="text">
									<strong>{{ userInfo.mem_name }}</strong> {{ userInfo.mem_rank_name }}
								</span>
							</li>
							<li class="info-item">
								<label class="label">M.</label>
								<span class="text">{{ userInfo.mem_mobile }}</span>
							</li>
							<li class="info-item">
								<label class="label">T.</label>
								<span class="text">02-6956-2791</span>
							</li>
							<li class="info-item">
								<label class="label">E.</label>
								<span class="text">{{ userInfo.mem_email }}</span>
							</li>
							<li class="info-item">
								<label class="label">F.</label>
								<span class="text">{{ userInfo.mem_fax || '070-4693-5728' }}</span>
							</li>
							<li class="info-item">
								<span class="text">서울특별시 강남구 학동로25길 11, 5층 (논현동, 씨플레이스)</span>
							</li>
						</ul>
						<!-- 신한/대신 제휴 게스트 PDF: 위온어스 중개법인 Contact Point 배너(첨부 디자인) 항상 표기 -->
						<div class="broker-corp" v-if="cobrandClass">
							<div class="bc-title">Contact Point</div>
							<div class="bc-corp"><strong>위온어스부동산중개법인</strong><span class="bc-addr"> (서울특별시 강남구 학동로25길 11, 5층(논현동, 씨플레이스))</span></div>
							<div class="bc-col bc-col1">
								<div class="bc-name">서치원 대표</div>
								<div class="bc-tel">+82 010-5566-4948</div>
							</div>
						</div>
						<div class="bottom-text">
							본 Teaser는 본 건 투자를 위한 기본적인 정보를 제공할 목적으로 작성되었습니다. Teaser의 세부적인 내용은
							추후 진행사항에 따라 수정되거나 변경될 수 있고, WEONUS 는 내용에 대해 어떠한 책임도 부담하지 않습니다.<br />
							또한 Teaser에서 제공한 정보는 어떠한 제약의 근거로 사용될 수 없습니다. Teaser의 어떠한 부분도 매도자 및
							WEONUS의 사전 동의 없이 외부에 복사, 인용, 재배포 및 유통될 수 없습니다.
						</div>
					</div>
				</template>
			</div>
		</div>
	</div>
</template>

<script>
import { normalizeAddr, formatBodyAddr } from '@/utils/format';
import {
	buildDefaults, computeAcquisition, computeDevelopment,
	computeFundingComparison, isResidential,
	serializeInvestment, applyInvestmentQuery, QUERY_KEYS,
} from '@/utils/investment.mjs';
import { serializeSlides, slidesFromQueryValue, makeBlankSlide, makePhotoSlide } from '@/utils/printSlides.mjs';
import { startPrintPage, markStage, markReady, markFailed } from '@/utils/printStatus.mjs';
import InvestmentAnalysisPage from '@/components/print/InvestmentAnalysisPage.vue';
import DevelopmentPlanPage from '@/components/print/DevelopmentPlanPage.vue';
import InvestmentSidebarEditor from '@/components/print/InvestmentSidebarEditor.vue';
import SlidePage from '@/components/print/SlidePage.vue';
import SlideEditor from '@/components/print/SlideEditor.vue';

export default {
	name: 'PrintPage2',
	components: {
		InvestmentAnalysisPage,
		DevelopmentPlanPage,
		InvestmentSidebarEditor,
		SlidePage,
		SlideEditor,
	},
	data() {
		return {
			loadSt: false,
			bid: null,
			bidList: null,

			indexList: [],
			capIdList: [],
			isPdfLoading: false,
			// F-5.1: progress indicator state for $exportPrint
			pdfLoadingMsg: '',
			pdfLoadingCurrent: 0,
			pdfLoadingTotal: 0,

			opAll: true,
			opList: [true, true, true, true, true, true, true, true],
			invShow: false,
			devShow: false,

			item: null,
			itemList: [],
			itemGroup: [],

			isBid: null,
			slideUploading: false,

			userInfo: {},
		};
	},
	created() {
		// F-6.1: 방어선 — bid 쿼리 누락/공백일 때 TypeError 로 빈 페이지가 뜨고
		// 그 상태로 출력 버튼이 노출되면 서버에 빈 idList 가 전송돼 1KB 백지 PDF 가 내려간다.
		// 명시적으로 alert + 복귀 후 init 을 스킵한다.
		const rawBid = this.$route.query.bid;
		if (!rawBid || typeof rawBid !== 'string') {
			alert('잘못된 접근입니다. 매물 목록에서 다시 시도해주세요.');
			this.$router.back();
			return;
		}
		// trailing comma / 연속 콤마로 생기는 빈 문자열은 제외 ("a,,b," → ["a","b"]).
		this.bidList = rawBid.split(',').map(s => s.trim()).filter(Boolean);
		if (this.bidList.length === 0) {
			alert('선택된 매물이 없습니다.');
			this.$router.back();
			return;
		}

		// ③④ 토글 상태 URL 복원(임대 기본 OFF; 서버 PDF 재로드 시 반영).
		if (this.$route.query.inv_show != null) this.invShow = String(this.$route.query.inv_show) !== '0';
		if (this.$route.query.dev_show != null) this.devShow = String(this.$route.query.dev_show) !== '0';

		for (let i = 0; i < this.bidList.length; i++) {
			this.bid = this.bidList[i];

			if (i == 0) {
				this.isBid = this.bid;
			}

			let dataObject = {
				id: this.bid,
				item: [],
				coverAddr: '',
				bodyAddr: '',
				rentList: [],
				floorList: [],
				totalData: {
					m2: 0,
					py: 0,
					deposit: 0,
					money: 0,
					mgr: 0,
				},
				totalFloorData: {
					m2: 0,
					py: 0,
				},

				rentRate: {
					labels: ['임대율'],
					datasets: [
						{
							label: '임대율',
							data: [0],
							backgroundColor: '#f87979',
						},
					],
				},
				rentRateSt: false,
				rentRateList: {
					labels: ['임대'],
					datasets: [],
				},
				rentRateListSt: false,

				map_1: null,
				marker_1: null,
				map_2: null,
				marker_2: null,
				mapType: null,
				slides: [],   // #7 부록 슬라이드(매물별)
			};

			this.itemList[this.bid] = dataObject;
		}

		// 지도 전용 출력 페이지(Panorama 미사용): base SDK(naver.maps.Map) 준비만 기다린다.
		// 'core' 로 호출해 panorama 서브모듈 지연/실패가 지도·PDF 렌더를 막지 않게 한다.
		this.mapScriptReady = this.$loadNaverMaps('core');

		// F-6.4: getItem 이 전체 bid 실패 시 throw 하므로 unhandled rejection 방지.
		// alert 는 getItem 내부에서 이미 띄워 사용자에게 알렸고, 여기서는 깔끔히 중단.
		startPrintPage();
		// init 이 중단되면 서버가 30초를 기다리게 두지 않고 원인을 실어 즉시 알린다.
		// (alert 는 getItem 내부에서 이미 사용자에게 띄웠다.)
		this.init().catch(e => {
			console.warn('init aborted:', e);
			markFailed('init aborted: ' + ((e && e.message) || e));
		});
	},
	computed: {
		// 페이지 워터마크 'weonus' 아래줄에 출력자(로그인 사용자) 이름 표기.
		watermarkStyle() {
			const name = (this.userInfo && this.userInfo.mem_name) || '';
			return name ? { '--print-watermark-name': `'${name.replace(/'/g, '')}'` } : {};
		},
		// 제휴 게스트(은행직원) 세션에서만 — 마지막 페이지 위온어스 × 기관 공동로고.
		cobrandClass() {
			if (!this.$store.getters.getGuest) return null;
			const inst = this.$store.getters.getInstitution;
			return inst === 'shinhan' || inst === 'daishin' ? inst : null;
		},
	},
	updated() {},
	methods: {
		async init() {
			// ─────────────────────────────────────────────────────────────
			// F-6.2: 연쇄출력(RentPrintPage2) capIdList / 지도 race 수정.
			//
			// 과거 동작:
			//   getItem() 내부 this.$nextTick 에서 getElementsByName('capture')
			//   으로 capIdList 를 수집 + __VUE_READY__ 를 세팅했다. 그런데 이 시점엔
			//   loadSt 가 아직 false → 템플릿 <div v-if="loadSt"> 가 DOM 에 존재하지
			//   않아 capIdList 가 [] 로 남았고, 클릭 시 $exportPdf([]) 가 호출돼
			//   서버가 0 개 섹션을 복제한 백지 1페이지 PDF(1,055 bytes) 를 반환했다.
			//   지도도 같은 이유로 mainMap_*/map_0_*/map_1_*/map_2_* 컨테이너를
			//   찾지 못해 "Container map_0_X not found" 가 찍히며 렌더 실패.
			//
			// 수정 동작:
			//   1. getItem — 데이터만 채움 (DOM 의존 작업 없음).
			//   2. rent/floor/user/land 를 Promise.all 로 병렬 수행 (속도 유지).
			//      각각 try/catch 로 하나가 실패해도 전체 출력이 중단되지 않도록 함.
			//   3. loadSt = true → 템플릿이 print-wrap 을 실제로 렌더.
			//   4. await $nextTick → capture 노드가 DOM 에 생성된 뒤 id 수집.
			//   5. 지도 스크립트가 준비되면 mainLoadMap/loadMap 호출 — 컨테이너 존재 보장.
			//   6. __VUE_READY__ = true → 서버 Puppeteer 가 이때부터
			//      page.waitForSelector(`#${id}`) 를 시도한다. capIdList 수집과
			//      지도 렌더가 끝난 뒤여야 Puppeteer 가 빈 섹션을 캡처하지 않는다.
			// ─────────────────────────────────────────────────────────────
			markStage('item-loading');
			await this.getItem();
			markStage('item-loaded');
			this.seedInvestmentStates();

			// 병렬 보조 데이터 로드 — 각 함수 내부가 이미 .catch 로 실패를 흡수하므로
			// Promise.all 로도 reject 가 올라오지 않는다. 하나의 느린/실패 요청이
			// 전체 init 을 중단시키지 못하도록 .catch 유지 + Promise.all 로 spec 준수.
			await Promise.all([
				this.getRent(),
				this.getFloor(),
				this.getUser(),
				this.getLand(),
			]);

			markStage('aux-loaded');
			this.loadSt = true;

			// print-wrap 이 실제로 DOM 에 생성되도록 다음 틱까지 대기.
			await this.$nextTick();

			// capture 섹션 id 수집 — 이 시점엔 항상 >0 개여야 정상.
			markStage('dom-rendered');
			this.capIdList = this.collectCaptureIds();

			// 지도 렌더 — 네이버 맵 스크립트 로드 실패해도 나머지 페이지는 출력 가능.
			try {
				await this.mapScriptReady;
				await this.$nextTick();
				for (let i = 0; i < this.itemGroup.length; i++) {
					this.mainLoadMap(this.itemGroup[i]);
				}
				for (let i = 0; i < this.bidList.length; i++) {
					const id = this.bidList[i];
					// 주의: DOM div 의 id 는 `map_0_${bid}` / `map_1_${bid}` /
					// `map_2_${bid}` 이므로 (template v-for="i in bidList" → i === bid),
					// loadMap 의 2번째 인자에도 반드시 `bid` 를 넘겨야 한다.
					// building_uid 는 DB 필드라 타입/값이 bid 와 다를 수 있어 id 불일치의
					// 잠재적 원인이 된다. bid 자체를 전달해 DOM id 와 1:1 정합 보장.
					this.loadMap(this.itemList[id].item, id);
				}
				// 네이버 지도는 타일을 비동기(<img>)로 로드한다. new Map() 직후엔
				// $nextTick 으로도 타일이 안 깔려 있어, Puppeteer 가 이 순간 캡처하면
				// 반쯤 그려진 맵이 찍힌다. 'idle' 이벤트(초기 타일 로드 완료)를
				// 맵마다 한 번씩 기다려야 한다. 타일 서버 장애 대비 3초 safety timeout.
				const allMaps = [];
				for (let i = 0; i < this.itemGroup.length; i++) {
					if (this.itemGroup[i].map) allMaps.push(this.itemGroup[i].map);
				}
				for (let i = 0; i < this.bidList.length; i++) {
					const entry = this.itemList[this.bidList[i]];
					if (entry?.map) allMaps.push(entry.map);
					if (entry?.map_1) allMaps.push(entry.map_1);
					if (entry?.map_2) allMaps.push(entry.map_2);
				}
				await Promise.all(
					allMaps.map(
						m =>
							new Promise(resolve => {
								let done = false;
								const finish = () => {
									if (!done) {
										done = true;
										resolve();
									}
								};
								try {
									window.naver.maps.Event.once(m, 'idle', finish);
								} catch (e) {
									finish();
									return;
								}
								// 3초 내 idle 이 안 떠도 출력은 진행 — 반쯤 그려진 편이
								// 영구 대기보다 낫다.
								setTimeout(finish, 3000);
							}),
					),
				);
				// 지도 타일이 DOM 에 attach 되는 한 틱 더 양보 — 서버 Puppeteer 가
				// waitForSelector 이후 곧바로 클론 캡처하면 빈 컨테이너가 찍히는 걸 방지.
				await this.$nextTick();
			} catch (e) {
				console.warn('Naver Maps script failed:', e);
			}

			// 서버 Puppeteer 대기 해제 — capIdList 와 지도 렌더 완료 이후 세팅.
			markReady();
		},
		getUser() {
			// F-6.2: init() 이 Promise.all 로 await 하므로 Promise 를 반환한다.
			// F-6.4: sibling fetcher(getRent/getFloor/getLand) 와 동일하게 .catch 로
			// reject 를 흡수한다. 없으면 /user/info 실패 시 Promise.all 이 reject →
			// init 이 loadSt=true 에 도달하지 못해 __VUE_READY__ 가 영구 false 가 되고
			// 서버 Puppeteer 가 타임아웃 → 사용자에게 빈 PDF 가 반환된다.
			return this.$apiGET('/admin/api/user/info').then(re => {
				this.userInfo = re || {};
			}).catch(e => { console.warn('getUser failed:', e); this.userInfo = {}; });
		},
		loadMap(item, id) {
			this.itemList[id].map = new window.naver.maps.Map('map_0_' + id, {
				center: new window.naver.maps.LatLng(37.5112, 127.0981),
				zoom: 16,
			});
			this.itemList[id].map.setCenter({ lat: item.pt.y, lng: item.pt.x });
			this.itemList[id].map.setSize({ width: '369px', height: '222px' });
			this.itemList[id].marker = new window.naver.maps.Marker({
				position: new window.naver.maps.LatLng(item.pt.y, item.pt.x),
				map: this.itemList[id].map,
			});

			this.itemList[id].map_1 = new window.naver.maps.Map('map_1_' + id, {
				center: new window.naver.maps.LatLng(37.5112, 127.0981),
				zoom: 16,
			});
			this.itemList[id].map_1.setCenter({ lat: item.pt.y, lng: item.pt.x });
			this.itemList[id].map_1.setSize({ width: '550px', height: '690px' });
			this.itemList[id].marker_1 = new window.naver.maps.Marker({
				position: new window.naver.maps.LatLng(item.pt.y, item.pt.x),
				map: this.itemList[id].map_1,
			});

			this.itemList[id].mapType = new window.naver.maps.CadastralLayer();

			this.itemList[id].map_2 = new window.naver.maps.Map('map_2_' + id, {
				center: new window.naver.maps.LatLng(37.5112, 127.0981),
				zoom: 18,
			});

			this.itemList[id].mapType.setMap(this.itemList[id].map_2);

			this.itemList[id].map_2.setCenter({ lat: item.pt.y, lng: item.pt.x });
			this.itemList[id].map_2.setSize({ width: '550px', height: '690px' });
			this.itemList[id].marker_2 = new window.naver.maps.Marker({
				position: new window.naver.maps.LatLng(item.pt.y, item.pt.x),
				map: this.itemList[id].map_2,
			});
		},
		mainLoadMap(isItem) {
			let max = 0;
			let pt = { x: 0, y: 0 };
			for (let i = 0; i < isItem.idList.length; i++) {
				const pt1 = this.itemList[isItem.idList[i]].item.pt;
				pt.x += pt1.x;
				pt.y += pt1.y;
				if (isItem.idList.length > 0) {
					for (let ii = 1; ii < isItem.idList.length; ii++) {
						const pt2 = this.itemList[isItem.idList[ii]].item.pt;

						const dis = this.calDist(pt1.y, pt1.x, pt2.y, pt2.x);

						if (max < dis) {
							max = dis;
						}
					}
				} else {
					max = 100;
				}
			}

			let zoomLevel = null;
			if (max >= 50000) {
				zoomLevel = 8;
			} else if (30000 <= max && max < 50000) {
				zoomLevel = 9;
			} else if (20000 <= max && max < 30000) {
				zoomLevel = 10;
			} else if (10000 <= max && max < 20000) {
				zoomLevel = 11;
			} else if (5000 <= max && max < 10000) {
				zoomLevel = 12;
			} else if (3000 <= max && max < 5000) {
				zoomLevel = 13;
			} else if (1000 <= max && max < 3000) {
				zoomLevel = 14;
			} else if (500 <= max && max < 1000) {
				zoomLevel = 15;
			} else {
				zoomLevel = 16;
			}

			isItem.map = new window.naver.maps.Map(isItem.mapIdName, {
				center: new window.naver.maps.LatLng(pt.y / isItem.idList.length, pt.x / isItem.idList.length),
				zoom: zoomLevel,
			});

			for (let i = 0; i < isItem.idList.length; i++) {
				const pt = this.itemList[isItem.idList[i]].item.pt;

				let marker = new window.naver.maps.Marker({
					position: new window.naver.maps.LatLng(pt.y, pt.x),
					map: isItem.map,
				});

				marker.setIcon({
					icon: 'HtmlIcon',
					content: `<span class="pin color-${i + 1}"><span class="num">${i + 1}</span></span>`,
				});

				isItem.markerList.push(marker);
			}

			// isItem.map.setCenter({ lat: this.item.pt.y, lng: this.item.pt.x });
			isItem.map.setSize({ width: '550px', height: '500px' });
		},
		calDist(lat1, lon1, lat2, lon2) {
			let EARTH_R = 6371000.0;
			let rad = Math.PI / 180;
			let radLat1 = rad * lat1;
			let radLat2 = rad * lat2;
			let radDist = rad * (lon1 - lon2);

			let distance = Math.sin(radLat1) * Math.sin(radLat2);
			distance = distance + Math.cos(radLat1) * Math.cos(radLat2) * Math.cos(radDist);
			let ret = EARTH_R * Math.acos(distance);

			return Math.round(ret); // 미터 단위
		},
		// ─── ③투자분석/④자금계획 (건물별) — 임대 다건, 기본 OFF ───────────────
		// 단일물건 mixin(investmentProposal) 은 this.item 단일 가정이라 연쇄출력엔 부적합.
		// 매물별 invState 를 itemList[bid] 에 시드하고, 페이지는 bid 별 헬퍼로 계산값을 주입.
		seedInvestmentStates() {
			for (const bid of this.bidList) {
				const it = this.itemList[bid];
				if (it && it.item) {
					it.invState = buildDefaults(it.item);
					// 담당자 저장 기본값(DB) 을 기본값 위에, 그 위에 URL(타직원 임시수정) 을 덮는다. (buildDefaults→DB→URL)
					// 단, 페이지 토글(inv_show/dev_show) 은 덱 전역 단일값이라 매물별 DB 값 미적용(의도).
					if (it.item.printDefaults && typeof it.item.printDefaults === 'object') {
						applyInvestmentQuery(it.invState, it.item.printDefaults);
					}
					this.applyInvestmentUrlOverride(bid); // 편집값(URL) 을 기본값 위에 덮어쓴다 — 서버 PDF 재로드 대비.
					// #7 슬라이드: DB(printDefaults.slides) → URL(slides_<bid>) 오버라이드.
					{ const dbSlides = it.item.printDefaults && it.item.printDefaults.slides; const urlSlides = (this.$route.query || {})['slides_' + bid]; it.slides = slidesFromQueryValue(urlSlides != null ? urlSlides : dbSlides); }
				}
			}
		},
		invStateOf(bid) {
			const it = this.itemList[bid];
			return it && it.invState ? it.invState : null;
		},
		invAcqOf(bid) {
			const s = this.invStateOf(bid);
			return s ? computeAcquisition(s) : null;
		},
		invDevOf(bid) {
			const s = this.invStateOf(bid);
			return s ? computeDevelopment(s) : null;
		},
		invFundingOf(bid) {
			const a = this.invAcqOf(bid);
			const d = this.invDevOf(bid);
			return (a && d) ? computeFundingComparison(a, d) : null;
		},
		invResidentialOf(bid) {
			const it = this.itemList[bid];
			return it && it.item ? isResidential(it.item.main_purpose) : false;
		},
		// 사이드바 편집(InvestmentSidebarEditor) → 즉시 URL 동기화(서버 PDF 재로드 대비).
		onInvestmentEdit() { this.syncInvestmentToUrl(); },
		onInvestmentToggle() { this.syncInvestmentToUrl(); },
		// #7 부록 슬라이드(매물별) ───────────────────────────────
		onSlideChange() { this.syncInvestmentToUrl(); },
		onSelectedAddBlank() { this.addBlankSlideOf(this.isBid); },
		onSelectedAddPhoto(file) { this.addPhotoSlideOf(this.isBid, file); },
		addBlankSlideOf(bid) {
			const it = this.itemList[bid];
			if (!it || !it.slides || it.slides.length >= 20) return;
			it.slides.push(makeBlankSlide(it.slides));
			this.syncInvestmentToUrl();
		},
		async addPhotoSlideOf(bid, file) {
			const it = this.itemList[bid];
			if (!it || !it.slides || !file || this.slideUploading || it.slides.length >= 20) return;
			this.slideUploading = true;
			try {
				const fd = new FormData();
				fd.append('image', file);
				fd.append('bid', it.item.building_uid);
				fd.append('type', 'rent');
				const token = (this.$store.getters.getToken || {}).accessToken || '';
				const res = await fetch(process.env.VUE_APP_HOST_BACK + '/admin/api/detail/item/print-slide/upload', {
					method: 'POST', headers: { Authorization: token }, body: fd,
				});
				const j = await res.json().catch(() => null);
				if (j && j.st && j.id) {
					it.slides.push(makePhotoSlide(it.slides, j.id, ''));
					this.syncInvestmentToUrl();
				} else {
					window.alert('사진 업로드 실패' + (j && j.reason ? ' (' + j.reason + ')' : ''));
				}
			} catch (e) {
				window.alert('사진 업로드 실패');
			} finally {
				this.slideUploading = false;
			}
		},
		// 매물별 invState 를 inv_<bid>_<키> 네임스페이스로 URL 직렬화. 검증된 serializeInvestment 재사용.
		// note 는 사이드바 미편집(상수 DEFAULT_NOTE)이라 제외 — 매물수만큼 중복 영속되는 URL 비대화 방지.
		syncInvestmentToUrl() {
			const u = new URL(window.location.href);
			[...u.searchParams.keys()].forEach(k => { if (k.indexOf('inv_') === 0 || k.indexOf('slides_') === 0) u.searchParams.delete(k); });
			for (const bid of this.bidList) {
				const it = this.itemList[bid];
				if (!it || !it.invState) continue;
				const q = serializeInvestment(it.invState);
				delete q[QUERY_KEYS.note];
				Object.entries(q).forEach(([key, v]) => u.searchParams.set('inv_' + bid + '_' + key, v));
				const sv = serializeSlides(it.slides);
				u.searchParams.set('slides_' + bid, sv == null ? '[]' : sv);
			}
			u.searchParams.set('inv_show', this.invShow ? '1' : '0');
			u.searchParams.set('dev_show', this.devShow ? '1' : '0');
			window.history.replaceState(window.history.state, '', u.pathname + u.search + u.hash);
		},
		// 서버 재로드 시 inv_<bid>_* 쿼리를 해당 매물 invState 기본값 위에 덮어쓴다.
		applyInvestmentUrlOverride(bid) {
			const it = this.itemList[bid];
			if (!it || !it.invState) return;
			const prefix = 'inv_' + bid + '_';
			const query = this.$route.query || {};
			const q = {};
			Object.keys(query).forEach(k => { if (k.indexOf(prefix) === 0) q[k.slice(prefix.length)] = query[k]; });
			applyInvestmentQuery(it.invState, q);
		},
		// 출력 파일명용 빌딩명: 첫 매물명(+ '외 N건'). seon.js 가 '위온어스_' 접두 부여.
		reportFileName() {
			const ids = Array.isArray(this.bidList) ? this.bidList : [];
			const first = (ids.length && this.itemList[ids[0]]) ? this.itemList[ids[0]].item.building_name : '';
			if (!first) return '';
			return ids.length > 1 ? `${first} 외 ${ids.length - 1}건` : first;
		},
		// 보이는(offsetParent!==null) + id 있는 capture 섹션만 수집한다.
		// 지도는 v-show 라 체크 해제해도 display:none 으로 DOM 에 잔존하는데, 이를 capIdList 에 담으면
		// 서버 PDF 가 그 섹션을 빈/거대 페이지로 렌더해 전체가 축소되고 빈 페이지가 늘어난다. 그래서 필터링.
		collectCaptureIds() {
			const ids = [];
			const nodes = document.getElementsByName('capture');
			for (let i = 0; i < nodes.length; i++) {
				const el = nodes[i];
				if (el.id && el.offsetParent !== null) ids.push(el.id);
			}
			return ids;
		},
		// invShow/devShow 토글로 ③④ v-if 페이지가 추가/제거된 뒤 capIdList stale 방지(출력 직전 재수집).
		rebuildCapIdList() {
			markStage('dom-rendered');
			this.capIdList = this.collectCaptureIds();
		},
		async copyChartImg() {
			this.isPdfLoading = true;
			this.pdfLoadingMsg = '출력 준비 중...';
			this.pdfLoadingCurrent = 0;
			this.pdfLoadingTotal = 0;
			// F-5.1: progress callback passed to $exportPrint
			const onProgress = (current, total) => {
				this.pdfLoadingTotal = total;
				this.pdfLoadingCurrent = current;
				this.pdfLoadingMsg = total > 1
					? `출력 준비 중... (${current}/${total} 페이지)`
					: '출력 준비 중...';
			};
			try {
				// F-6.4: 출력로그 기록은 await 하되, 실패가 PDF 다운로드를 막지 않도록 격리.
				try {
					await this.$apiPOST('/admin/api/detail/item/print2', { bidList: this.bidList });
				} catch (logErr) {
					console.warn('print log failed (non-blocking):', logErr);
				}
				try {
					this.syncInvestmentToUrl(); // 편집 투자분석 입력값을 URL 에 반영(서버 PDF 재로드 대비)
					this.rebuildCapIdList(); // ③④ 토글 후 capIdList 최신화(stale 셀렉터 hang 방지)
					await this.$exportPdf(this.capIdList, this.reportFileName());
				} catch (e) {
					console.warn('Server PDF failed, falling back to client-side:', e);
					await this.$exportPrint(this.capIdList, onProgress, this.reportFileName());
				}
			} finally {
				this.isPdfLoading = false;
				this.pdfLoadingMsg = '';
			}
		},
		async getItem() {
			// F-6.3: $apiGET 은 400/네트워크 실패 시 boolean `false` 를 반환한다(seon.js 참조).
			// 과거엔 그대로 `data.img = null` 을 건드려 TypeError 로 init 이 멈추고
			// loadSt 가 true 로 세팅되지 못해 DOM 이 영영 렌더되지 않았다.
			// 실패한 bid 는 failedBids 에 모아 itemList/bidList 에서 제거하고,
			// 전부 실패한 경우에만 alert + throw 로 명시적으로 중단한다.
			const failedBids = [];
			for (let i = 0; i < this.bidList.length; i++) {
				const bid = this.bidList[i];

				const data = await this.$apiGET('/admin/api/detail/item?bid=' + bid + '&isRent=true');

				if (!data || typeof data !== 'object') {
					console.warn('getItem failed for bid', bid, '→ skipping');
					failedBids.push(bid);
					continue;
				}

				for (let prop in data) {
					if (data[prop] == null) {
						data[prop] = '';
					}
				}

				data.img = null;

				//썸네일
				for (let i = 0; i < data.imgList.length; i++) {
					if (data.imgList[i]) {
						data.img = process.env.VUE_APP_HOST_BACK + '/users/item/image2?id=' + data.imgList[i] + '&w=1200&q=82';
						break;
					}
				}

				//이미지 리스트
				let imgObjList = [];
				for (let i = 0; i < data.imgList.length; i++) {
					if (data.imgList[i]) {
						imgObjList.push({
							// I1: 사용자 라벨 우선, fallback IMG_NAME.
							name: (data.imgLabels && data.imgLabels[i] && data.imgLabels[i].length) ? data.imgLabels[i] : this.$IMG_NAME[i],
							img: process.env.VUE_APP_HOST_BACK + '/users/item/image2?id=' + data.imgList[i] + '&w=1200&q=82',
							st: true,
						});
					}
				}

				data.imgObjList = imgObjList;

				let imgObj = [];
				for (let i = 0; i < imgObjList.length; i += 2) {
					imgObj.push(imgObjList.slice(i, i + 2));
				}

				data.imgObj = imgObj;

				this.itemList[bid].item = data;

				// F-5.2: fallback — use building's own address until land parcels load
				// F-2.1: legacy row 방어선 — 원시 "서울특별시 … 번지" 포맷도 정규화.
				if (!this.itemList[bid].coverAddr) {
					const fallback = normalizeAddr(data.jibun_addr);
					this.itemList[bid].coverAddr = fallback;
					this.itemList[bid].bodyAddr = fallback;
				}
			}

			// F-6.3: 실패한 bid 는 렌더 루프/지도 생성에서 제외하고 itemList 엔트리도 제거.
			// 전부 실패했다면 더 진행해도 빈 페이지만 찍히므로 명시적으로 중단.
			if (failedBids.length > 0) {
				for (const fb of failedBids) {
					delete this.itemList[fb];
				}
				this.bidList = this.bidList.filter(b => !failedBids.includes(b));
				if (this.bidList.length === 0) {
					alert('매물 정보를 불러오지 못했습니다.');
					throw new Error('getItem: all bids failed');
				}
				// isBid 가 실패 bid 를 가리키고 있으면 첫 성공 bid 로 재지정.
				if (failedBids.includes(this.isBid)) {
					this.isBid = this.bidList[0];
				}
			}

			this.itemGroup = [];
			for (let i = 0; i < this.bidList.length; i += 3) {
				this.itemGroup.push({
					idList: this.bidList.slice(i, i + 3),
					domIdName: 'capdom_' + i,
					mapIdName: 'mainMap_' + i,
					map: null,
					markerList: [],
				});
			}

			this.capIdList = [];

			// F-6.4: indexList 재생성 — updateId() 와 동일 로직을 buildIndexList() 로 공유.
			this.indexList = this.buildIndexList();

			// F-6.2: capIdList 수집·__VUE_READY__·지도 렌더는 init() 으로 이동.
			// loadSt=true 이후의 $nextTick 에서만 DOM 이 보장되기 때문.
		},
		// F-6.4: getItem / updateId 두 곳에서 동일했던 indexList 재생성 루프를
		// 단일 메서드로 추출. 호출자는 `this.indexList = this.buildIndexList();`
		// 형태로 대입해 사용한다. 출력 문구(비교/물건개요/.../END)와 인덱스
		// 포맷(`'0' + idx + '. '`)은 기존 동작과 byte-identical.
		buildIndexList() {
			const list = [];
			let idx = 1;
			for (let i = 1; i < this.opList.length; i++) {
				if (this.opList[i]) {
					if (i == 1) {
						list.push({
							idx: '0' + idx + '. ',
							name: '비교',
						});
					} else if (i == 2) {
						list.push({
							idx: '0' + idx + '. ',
							name: '물건개요',
						});
					} else if (i == 3) {
						list.push({
							idx: '0' + idx + '. ',
							name: '임대정보',
						});
					} else if (i == 4) {
						list.push({
							idx: '0' + idx + '. ',
							name: '건축물정보',
						});
					} else if (i == 5) {
						list.push({
							idx: '0' + idx + '. ',
							name: '건축 내/외부 사진',
						});
					} else if (i == 6) {
						list.push({
							idx: '0' + idx + '. ',
							name: '지도',
						});
					} else if (i == 7) {
						list.push({
							idx: '0' + idx + '. ',
							name: 'END',
						});
					}
					idx++;
				}
			}
			return list;
		},
		updateId() {
			for (let i = 0; i < this.bidList.length; i++) {
				const bid = this.bidList[i];

				let data = JSON.parse(JSON.stringify(this.itemList[bid].item));

				//이미지 리스트
				let imgObjList = [];
				for (let i = 0; i < data.imgObjList.length; i++) {
					if (data.imgObjList[i].st) {
						imgObjList.push(data.imgObjList[i]);
					}
				}

				let imgObj = [];
				for (let i = 0; i < imgObjList.length; i += 2) {
					imgObj.push(imgObjList.slice(i, i + 2));
				}

				this.itemList[bid].item.imgObj = imgObj;
			}

			this.$nextTick(() => {
				// F-6.4: getItem() 과 동일 로직을 buildIndexList() 공유 메서드로 위임.
				this.indexList = this.buildIndexList();

				markStage('dom-rendered');
				this.capIdList = this.collectCaptureIds();

				if (this.opList[1]) {
					for (let i = 0; i < this.itemGroup.length; i++) {
						this.mainLoadMap(this.itemGroup[i]);
					}
				}
			});
		},
		getRent() {
			// F-6.2: init() 이 Promise.all 로 await 하도록 Promise.all 반환.
			const promises = this.bidList.map(bid => {
				return this.$apiGET('/admin/api/detail/item/rent2?bid=' + bid).then(data => {
					// F-6.3: $apiGET 실패 시 false 가 반환될 수 있다 → 빈 배열로 대체.
					if (!Array.isArray(data)) data = [];
					let m2 = 0;
					let py = 0;
					let deposit = 0;
					let money = 0;
					let mgr = 0;

					let cnt = data.length;
					let sumCnt = 0;

					for (let i = 0; i < data.length; i++) {
						if (data[i].rent_money) {
							sumCnt++;
						}

						// 면적은 항상 합산 (F-3.4)
						m2 += Number(data[i].rent_size_m2);
						py += Number(data[i].rent_size_p);
						if (data[i].except_flag != 'Y') {
							deposit += Number(data[i].rent_deposit);
							money += Number(data[i].rent_money);
							mgr += Number(data[i].mgr_fee);
						}
					}

					if (cnt) {
						this.itemList[bid].rentRate.datasets[0].data[0] = Number(((sumCnt / cnt) * 10 * 10).toFixed(2));
					} else {
						this.itemList[bid].rentRate.datasets[0].data[0] = 0;
					}

					const rentGroup = this.$groupBy(data, 'rent_usage');
					for (let prop in rentGroup) {
						const curCnt = rentGroup[prop].length;
						this.itemList[bid].rentRateList.datasets.push({
							label: prop,
							data: [Number(((curCnt / cnt) * 100).toFixed(2))],
						});
					}

					this.itemList[bid].rentRateSt = true;
					this.itemList[bid].rentRateListSt = true;

					this.itemList[bid].rentList = data;
					this.itemList[bid].totalData.m2 = m2.toFixed(2);
					this.itemList[bid].totalData.py = py.toFixed(2);
					this.itemList[bid].totalData.deposit = deposit;
					this.itemList[bid].totalData.money = money;
					this.itemList[bid].totalData.mgr = mgr;
				}).catch(e => { console.warn('getRent failed for bid', bid, e); });
			});
			return Promise.all(promises);
		},
		getFloor() {
			// F-6.2: init() 이 Promise.all 로 await 하도록 Promise.all 반환.
			const promises = this.bidList.map(bid => {
				return this.$apiGET('/admin/api/detail/item/floor2?bid=' + bid).then(data => {
					// F-6.3: $apiGET 실패 시 false 가능 → 빈 배열로 대체.
					if (!Array.isArray(data)) data = [];
					let m2 = 0;
					let py = 0;

					for (let i = 0; i < data.length; i++) {
						// 건축물대장이 면적 제외로 표시한 행(옥탑 계단실 등)은 연면적에 들지 않는다(DD). 담당자 제외 체크와는 별개다.
						if (String(data[i].areaExctYn) === '1') continue;
						m2 += Number(data[i].area_m2);
						py += Number(data[i].area_py);
					}

					this.itemList[bid].floorList = data;
					this.itemList[bid].totalFloorData.m2 = m2.toFixed(2);
					this.itemList[bid].totalFloorData.py = py.toFixed(2);
				}).catch(e => { console.warn('getFloor failed for bid', bid, e); });
			});
			return Promise.all(promises);
		},
		getLand() {
			const promises = this.bidList.map(bid => {
				return this.$apiGET('/admin/api/detail/item/edit/land2?bid=' + bid).then(data => {
					// F-2.1: legacy row 방어선 — 렌더 직전에 정규화.
					// F-6.3: $apiGET 실패 시 false 가능 → fallback 유지.
					if (!Array.isArray(data)) return;
					const uniqueAddrs = [...new Set(
						data.map(d => normalizeAddr(d.jibun_addr)).filter(Boolean)
					)];
					if (uniqueAddrs.length > 1) {
						this.itemList[bid].coverAddr = uniqueAddrs[0] + ' 외 ' + (uniqueAddrs.length - 1) + '필지';
					} else if (uniqueAddrs.length === 1) {
						this.itemList[bid].coverAddr = uniqueAddrs[0];
					}
					// F-5.2: 본문은 시/구 제거 + 동일 동 반복 생략 포맷.
					this.itemList[bid].bodyAddr = formatBodyAddr(uniqueAddrs) || this.itemList[bid].coverAddr;
				}).catch(() => { /* fallback already set for this bid */ });
			});
			return Promise.all(promises);
		},
		setAllCheck() {
			for (let i = 0; i < this.opList.length; i++) {
				this.opList[i] = this.opAll;
			}
			this.updateId();
		},
	},
};
</script>

<style lang="scss" scoped>
// F-5.5 print layout red theme
.section-tit--print-header {
	background-color: #a23334;
	color: #fff !important;
	border-color: #a23334 !important;
	padding: 6px 10px;
	border-radius: 2px;
}

// F-3.5 제외 row 연회색 처리 스타일은 assets/css/common.scss 로 이동 (전역 단일 정의).
.pdf-loading-overlay {
	position: fixed;
	top: 0;
	left: 0;
	right: 0;
	bottom: 0;
	background: rgba(0, 0, 0, 0.5);
	display: flex;
	align-items: center;
	justify-content: center;
	z-index: 9999;
}
.pdf-loading-spinner {
	background: white;
	padding: 30px 50px;
	border-radius: 8px;
	font-size: 18px;
	font-weight: bold;
	min-width: 260px;
	text-align: center;
}
.pdf-loading-text {
	margin-bottom: 14px;
}
.pdf-loading-bar-wrap {
	width: 100%;
	height: 8px;
	background: #e0e0e0;
	border-radius: 4px;
	overflow: hidden;
}
.pdf-loading-bar {
	height: 100%;
	background: #1976d2;
	border-radius: 4px;
	transition: width 0.25s ease;
}
</style>
